import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=38075c23&"
import script from "./ButtonLink.vue?vue&type=script&lang=js&"
export * from "./ButtonLink.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ButtonLink.vue"
export default component.exports